import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "100%",
    overflow: "hidden",
    padding: "2rem",
    background: "linear-gradient(180deg, #00351A 0%, #1B1B1B 100%)",
    minHeight: "100vh",
    "@media (max-width: 500px)": {
      padding: "0.5rem",
    },
  },
  container: {
    padding: "39px",
    borderRadius: "16px",
    backgroundColor: "#00351A",
    position: "relative",
    overflow: "hidden",
    "@media (max-width: 650px)": {
      padding: "20px",
    },
  },
  margincont: {
    backgroundColor: "#001E0F",
    padding: "39px",
    borderRadius: "16px",
    "@media (max-width: 600px)": {
      padding: "1rem",
    },
  },
  content: {
    maxWidth: "800px",
    margin: "auto",
    textAlign: "center",
    color: "#FFF",
    position: "relative",
    zIndex: 10,
    padding: "60px 20px",
    "@media (max-width: 600px)": {
      padding: "40px 10px",
    },
  },
  errorCode: {
    fontSize: "180px",
    fontWeight: 700,
    lineHeight: "1",
    marginBottom: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    color: "#FFF",
    "@media (max-width: 768px)": {
      fontSize: "120px",
    },
    "@media (max-width: 500px)": {
      fontSize: "80px",
      gap: "5px",
    },
  },
  zero: {
    display: "inline-block",
    background: "linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%)",
    borderRadius: "50%",
    width: "140px",
    height: "140px",
    lineHeight: "140px",
    textAlign: "center",
    boxShadow: "0 10px 40px rgba(76, 175, 80, 0.3)",
    "@media (max-width: 768px)": {
      width: "90px",
      height: "90px",
      lineHeight: "90px",
    },
    "@media (max-width: 500px)": {
      width: "60px",
      height: "60px",
      lineHeight: "60px",
    },
  },
  title: {
    fontSize: "48px",
    fontWeight: 700,
    marginBlock: "20px",
    color: "#FFF",
    "@media (max-width: 768px)": {
      fontSize: "36px",
    },
    "@media (max-width: 500px)": {
      fontSize: "28px",
      marginBlock: "15px",
    },
  },
  message: {
    fontSize: "20px",
    lineHeight: "160%",
    marginBlock: "0px 40px",
    color: "#CCC",
    maxWidth: "600px",
    margin: "0 auto 40px",
    "@media (max-width: 768px)": {
      fontSize: "18px",
    },
    "@media (max-width: 500px)": {
      fontSize: "16px",
      marginBottom: "30px",
    },
  },
  buttonContainer: {
    marginTop: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "@media (max-width: 500px)": {
      marginTop: "30px",
    },
  },
  illustration: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    height: "100%",
    zIndex: 1,
    pointerEvents: "none",
  },
  circle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "300px",
    height: "300px",
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(76, 175, 80, 0.2) 0%, transparent 70%)",
    "@media (max-width: 768px)": {
      width: "200px",
      height: "200px",
    },
  },
  circle2: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "400px",
    height: "400px",
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(76, 175, 80, 0.15) 0%, transparent 70%)",
    "@media (max-width: 768px)": {
      width: "280px",
      height: "280px",
    },
  },
  circle3: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "500px",
    height: "500px",
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(76, 175, 80, 0.1) 0%, transparent 70%)",
    "@media (max-width: 768px)": {
      width: "350px",
      height: "350px",
    },
  },
}));

export default useStyles;
